<template>
  <div>
    <h4 v-if="limitSecond > 0">
      {{ "time_ower" | setText("Осталось секунд:") }} {{ limitSecond }}
    </h4>

    <div>
      <div class="row">
        <div class="col-12" v-if="file_url">
          <a target="_blank" class="btn mb-2" :href="file_url">
            {{ "donwload_file_must" | setText("Скачать документ") }}</a
          >
        </div>
        <div class="col-12 col-md-12">
          <fg-input
            :type="`text`"
            :label="`Код из смс`"
            :labelKey="`sms_code`"
            v-model="data.code"
          ></fg-input>
        </div>
      </div>

      <div class="install-control">
        <button @click="send" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  computed: {
    file_url() {
      let file = "";
      if (
        this.transaction.api_result &&
        this.transaction.api_result["file_url"]
      ) {
        file = this.transaction.api_result["file_url"].replace(/\?.*$/, "");
      } else if (this.value && this.value["file_url"]) {
        file = this.value["file_url"];
      }

      return file;
    },
  },
  watch: {
    limitSecond(val) {
      if (val < 1) {
        alert("Время истелко!!");
      }
    },
  },
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    setInterval(() => {
      this.limitSecond--;
    }, 1000);
  },
  methods: {
    send() {
      this.$loading(true);
      let data = {};
      data["loan_id"] = this.transaction["exchange_id"];
      data["otp_id"] = this.value["otp_id"];
      data["client_otp"] = this.data.code;

      this.$http({
        url: `${this.partner["endpoint_url"]}confirm-sign-contract-otp`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              step: "send-signed-contract",
              client_confirmed: 1,
              status: 1,
              pre_api_result: JSON.stringify(response.data),
            });

            this.$emit("setStep", "send-signed-contract");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        code: null,
      },
      limitSecond: 120,
    };
  },
};
</script>

